import { Component, OnInit } from '@angular/core';
import { ErrorHandler } from '../../shared/ErrorHandler';
import { UserService } from '../../shared/user.service';

@Component({
  selector: 'app-client-open-nclosed-ticket-count',
  templateUrl: './client-open-nclosed-ticket-count.component.html',
  styleUrls: ['./client-open-nclosed-ticket-count.component.css']
})
export class ClientOpenNclosedTicketCountComponent implements OnInit {

  constructor( private userService: UserService,private errorHandler: ErrorHandler ) { }

  ngOnInit() {
    this.ClientsAllTicketCount()
  }

  ClientsAllTicketCount = function(){
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.clientsAllTicketCount()
    .subscribe((data:any)=>{
      this.ClientList = data;
      document.getElementById('loader-spinner').style.display = "none";
    },(error)=>{
      document.getElementById('loader-spinner').style.display = "none";
      this.errorHandler.HandlerError(error);
    });

}
}



// WEBPACK FOOTER //
// ./src/app/reports/client-open-nclosed-ticket-count/client-open-nclosed-ticket-count.component.ts